export default __webpack_public_path__ + "static/media/icon_location_power_outage_false.85f47fe7.svg";